
export enum ExerciseType {
  SQUAT = 'SQUAT',
  PUSHUP = 'PUSHUP',
  JUMPING_JACK = 'JUMPING_JACK',
  SITUP = 'SITUP',
}

export enum WorkoutMode {
  FREE = 'FREE',
  TIME_ATTACK = 'TIME_ATTACK',
}

export interface WorkoutSession {
  id: string;
  date: string;
  exercise: ExerciseType;
  mode?: WorkoutMode; 
  targetDuration?: number;
  reps: number;
  durationSeconds: number;
  accuracyScore: number; 
  userId?: string;
  nickname?: string;
  photoURL?: string;
  timestamp?: number;
}

export interface PoseLandmark {
  x: number;
  y: number;
  z: number;
  visibility?: number;
}

export enum ExerciseState {
  IDLE = 'IDLE',
  DOWN = 'DOWN',
  UP = 'UP',
}

export interface RepContext {
  count: number;
  state: ExerciseState;
  feedback: string;
  lastRepTime: number;
  formScore: number;
}

// MediaPipe Types
export interface Results {
  poseLandmarks: PoseLandmark[];
  poseWorldLandmarks: PoseLandmark[];
  segmentationMask: any;
}

// Profile & Leaderboard Types
export enum FitnessLevel {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED',
  ELITE = 'ELITE',
}

export interface UserProfile {
  uid: string;
  nickname: string; // Maps to "Name"
  email?: string;
  country?: string;
  age?: number;
  dob?: string; // Date of Birth
  image_URL?: string; // Maps to "image_URL"
  photoURL?: string; // Kept for internal app compatibility
  fitnessLevel: FitnessLevel;
  createdAt: number;
}

export interface LeaderboardEntry {
  userId: string;
  nickname: string;
  photoURL?: string;
  date: string;
  reps: number;
  accuracy: number;
  exercise: string;
  duration: number;
}

declare global {
  interface Window {
    Pose: any;
    Camera: any;
    drawConnectors: any;
    drawLandmarks: any;
    POSE_CONNECTIONS: any;
  }
}
